import React from 'react';

import { preAlertApis } from '@apis/next/preAlertApis';
import fcslLogo from '@assets/img/arts/fcsl-logo.png';
import { ExportPreAlert as ExportPreAlertComponent } from '@components/ExportPreAlert';
import { Layout } from '@components/Layout';
import { bookingsStrings } from '@data/bookings';
import { useSearch } from '@hooks/next/useSearch';
import { makeMuiStyles } from '@styles';
import { url } from '@utils/pages';
import { z } from 'zod';

const useStyles = makeMuiStyles((theme, _common) => ({
  background: {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const ExportPreAlert: React.FC = () => {
  const classes = useStyles();

  const { search } = useSearch(
    z.object({
      d2dNo: z.string(),
    }),
  );

  const preAlert = preAlertApis.useGet('/pre-alert/:d2d_no', {
    params: {
      d2d_no: search.d2dNo,
    },
  });

  const loading = preAlert.isLoading;

  const updatedAt = preAlert.data?.updated_at;

  return (
    <Layout
      hideHeader
      hideFooter
      hideCookiePolicy
      loading={loading}
      title={bookingsStrings.currentBookings}
      errors={[preAlert.error]}
      classes={{
        background: classes.background,
      }}
    >
      <ExportPreAlertComponent
        fcLogo={fcslLogo}
        preAlert={preAlert.data}
        updatedAt={updatedAt}
        logLink={`${url('/utilities/Bookings/PrintPreAlertLog')}?id=${preAlert.data
          ?.booking_inquiry!}`}
      />
    </Layout>
  );
};
